export const createNewVisitTool = (handler) => {
  return {
    type: 'function',
    name: 'start_new_visit',
    description: 'Initializes and registers a new visit in the system. This can be called more than once.',
    parameters: {
      type: 'object',
      strict: true,
      properties: {},
      required: [],
    },
    handler: handler,
  };
};
